async function postAuth(path: string, body: Record<string, unknown>) {
  const response = await fetch(`/api/auth${path}`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const payload = (await response.json().catch(() => undefined)) as
      | { message?: string; error?: { message?: string } }
      | undefined;

    throw new Error(payload?.message ?? payload?.error?.message ?? response.statusText);
  }
}

export async function resendEmailVerificationOTP(email: string) {
  await postAuth("/email-otp/send-verification-otp", {
    email,
    type: "email-verification",
  });
}

export async function verifyEmailOTP(email: string, otp: string) {
  await postAuth("/email-otp/verify-email", {
    email,
    otp,
  });
}
